// extracted by mini-css-extract-plugin
export default {"btn":"PaginationBtn_btn__lC2tf","btnActive":"PaginationBtn_btnActive__q3K0o"};